var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSmallArrowLeft = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  strokeWidth: 0.75,
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M2.668 8c0-.369.298-.667.667-.667h9.333a.667.667 0 0 1 0 1.333H3.335a.667.667 0 0 1-.667-.667Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M8.473 2.861c.26.26.26.683 0 .943L4.277 8l4.196 4.196a.667.667 0 1 1-.943.942L2.863 8.471a.667.667 0 0 1 0-.943L7.53 2.86c.26-.26.682-.26.943 0Z",
  clipRule: "evenodd"
})));
SvgSmallArrowLeft.viewBox = '0 0 16 16';
const ForwardRef = /*#__PURE__*/forwardRef(SvgSmallArrowLeft);
export default ForwardRef;